//----------------------------------------------------------------------------------------------------------------
// Copyright DeerSoft - 2019
//----------------------------------------------------------------------------------------------------------------
let ipcRenderer;
let registerdAsyncCallbacks   = []
let callbackMap                 = new Map();
let callBackid                  = 0;

let LightRightAsyncCall = undefined
let LightRightCall      = undefined

function __IsElectronContext()
{
  return (window && window.process && window.process.type);
}

window.LR_IOS_EnableRotation = () =>  { }

window.getQuery = (paramName) => {
    let query = new URLSearchParams(window.location.search)
    return query.get(paramName)
}

let contextBridge = 
{
    exposeInMainWorld: (name, func)=>{window[name] = func}
}

console.log("preload me")

let ElectronWebsocketMode = window.ElectronWebsocketMode
if(__IsElectronContext())
{
    let res = window.GetElectron().ipcRenderer.sendSync("LR_E_GetElectronWebsocketMode",  {});
    ElectronWebsocketMode = res
    console.log("ElectronWebsocketMode", ElectronWebsocketMode, res)
}


if(process.env.JEST_WORKER_ID) 
{
    console.log = () =>{}
    LightRightCall = async function  (command, object = {})
    {
        return window.LightRightCore[command](object)
    }

    LightRightAsyncCall = async function (command, object = {})
    {
        return window.LightRightCore[command]({object, Async: false})
    }
}
else if (ElectronWebsocketMode)
{
    if(__IsElectronContext())
    {
        contextBridge = window.GetElectron().contextBridge;
        contextBridge.exposeInMainWorld('ElectronWebsocketMode', true)
    }
    else
    {
        contextBridge.exposeInMainWorld('ElectronWebsocketMode', ElectronWebsocketMode)
        contextBridge.exposeInMainWorld('IsLocalViewMode', true)
    }
    

    ipcRenderer =
    {
        connect: async function()
        {
            if(__IsElectronContext())
            {
                this.__WebSocket = {readyState: 0}
                let portList = window.GetElectron().ipcRenderer.sendSync("LR_E_GetAvailableWebsocketPorts",  {});
                this.__WebSocket = new WebSocket(`ws://localhost:${portList[portList.length - 1].port}`);
                this.__WebSocket.onmessage = this.receive
                window.GetElectron().ipcRenderer.on("toggleContainer", this.toggleContainer)
            }
            else
            {
                const params = new URLSearchParams(window.location.search);
                const targetUrl = params.get('url');

                this.__WebSocket = {readyState: 0}
                this.__WebSocket = new WebSocket(`ws://${targetUrl}`);
                this.__WebSocket.onmessage = this.receive
            }
        },
    
        sendMessage: function(arg)
        {
            if (this.__WebSocket.readyState === 1)
            {
                this.__WebSocket.send(JSON.stringify(arg));
                return true;
            }
    
            return new Promise((res, req) =>
            {
                let func = () =>
                {
                    if (this.__WebSocket.readyState === 1)
                    {
                        this.__WebSocket.send(JSON.stringify(arg));
                        res(true);
                    }
                    else
                    {
                        setTimeout(func, 50);
                    }
                }
                setTimeout(func, 50);
            })
        },
    
        receive: function(event)
        {
            let payload = JSON.parse(event.data);
            if(payload.Type === "CALLBACK")
            {
                exposedIpc.execute("OnLightRightCoreCallback", payload.Object)
            }
            else
            {
                window.revolve(payload.CallbackID, payload.Argument)
            }
        },

        toggleContainer: function(event, payload)
        {
            exposedIpc.execute("toggleContainer", payload)
        }
    }

    let exposedIpc = {
        CallBackMap: {},
        on: (name, func) =>
        {
            exposedIpc.CallBackMap[name] = func
        },
        execute: (name, data) =>
        {
            if(exposedIpc.CallBackMap[name])
            {
                exposedIpc.CallBackMap[name]({},data)
            }
        }
    }

    window.revolve = function (id, result)
    {
        let callback = callbackMap.get(id)
        if (callback)
        {
            callback(result);
        }else if(id<= 0){
            console.error(`unable to find callback for id ${id}`, result)
        }
        callbackMap.delete(id);
    }

    LightRightCall = async function (command, object)
    {
        // In case both the main UI and the Plugin is used, avoid clashing between these two, 
        // by working with different sets of callbackIDS (one positive -> Main UI, one negative -> Websocket UI)
        let thisId = callBackid--;
        let req =
        {
            CallbackID: thisId,
            Command: command,
            Object: object
        };

        let prom = new Promise((res, rej) => { callbackMap.set(thisId, res);  });
        ipcRenderer.sendMessage(req);
        return prom
    }

    LightRightAsyncCall = async function (command, object)
    {
        let thisId = callBackid--;
        let req =
        {
            Command: command,
            Object: object
        };
        if(req.Object === undefined){ req.Object = {} }
        req.Object.CallbackID = thisId

        let prom = new Promise((res, rej) => { callbackMap.set(thisId, res);  });

        ipcRenderer.sendMessage(req)
        return prom
    }

    let electron_ipcRenderer = exposedIpc
    if(__IsElectronContext())
    {
        electron_ipcRenderer   = window.GetElectron().ipcRenderer;
    }
    else
    {
        electron_ipcRenderer.sendSync = ()=>{}
    }
    
    

    contextBridge.exposeInMainWorld('ipcRenderer', exposedIpc)
    
    contextBridge.exposeInMainWorld('LR_E_MainMenu', (theMenu) => 
    {
        electron_ipcRenderer.sendSync("LR_E_MainMenu", theMenu);
    })
    contextBridge.exposeInMainWorld('LR_E_UpdateMacToolbar', (theMenu) => 
    {
        electron_ipcRenderer.sendSync("update-mac-touchbar", {});
    })

    contextBridge.exposeInMainWorld('LR_E_RightClickMenu', (theMenu) => 
    {
        electron_ipcRenderer.sendSync("LR_E_RightClickMenu", theMenu);
    })

    contextBridge.exposeInMainWorld('LR_E_DisableElectronToSendShortCuts', (option) => 
    {
        electron_ipcRenderer.sendSync("LR_E_DisableElectronToSendShortCuts", option);
    })
    
    contextBridge.exposeInMainWorld('LR_E_SetMainWindowTitle', (title) => 
    {
        electron_ipcRenderer.sendSync("LR_E_SetMainWindowTitle", title);
    })

    contextBridge.exposeInMainWorld('LR_E_SetAppMode', (title) => 
    {
        electron_ipcRenderer.sendSync("LR_E_SetAppMode", title);
    })
    
    
    electron_ipcRenderer.on("COMMAND", (event, arg)=>
    {
        LightRightCall(arg.CMD, arg.ARG)
    })
    
    electron_ipcRenderer.on("LR_E_SetAppModeReload", (event, arg)=>
    {
        window.location.reload()
    })
    
    ipcRenderer.connect()
}
else if(__IsElectronContext()) 
{
    ipcRenderer   = window.GetElectron().ipcRenderer;
    contextBridge = window.GetElectron().contextBridge;
    let webUtils = window.GetElectron().webUtils;
    
    contextBridge.exposeInMainWorld('ipcRenderer', {
        on: (name, func) =>
        {
            ipcRenderer.on(name, func)
        }
    })

    contextBridge.exposeInMainWorld('electron', {
        showFilePath (file) {
          // It's best not to expose the full file path to the web content if
          // possible.
          const path = webUtils.getPathForFile(file)
          return path
        }
      })


    ipcRenderer.on("LR_E_SetAppMode", (event, arg)=>
    {
        window.location.reload()
    })

    contextBridge.exposeInMainWorld('PA_IsElectronContext', true)
    contextBridge.exposeInMainWorld('ElectronWebsocketMode', false)


    LightRightCall = function (command, object = {})
    {
        const ret = ipcRenderer.invoke("OnLightRightCall", {channel:command,  arg: object});
        return ret
    }

    LightRightAsyncCall =  function (command, object = {})
    {
        let thisId = callBackid++;
        if(object === undefined){ object = {} }
        object.CallbackID = thisId
        
        ipcRenderer.send("OnLightRightCallAsync", {channel:command,  arg: object});
        let prom = new Promise((resolve, reject) => 
        {
            ipcRenderer.once(command+thisId, (event, arg) => 
            {
                resolve(arg)   
            })
        })
    
        return prom;
    }

    contextBridge.exposeInMainWorld('LR_E_MainMenu', (theMenu) => 
    {
        ipcRenderer.sendSync("LR_E_MainMenu", theMenu);
    })
    contextBridge.exposeInMainWorld('LR_E_UpdateMacToolbar', (theMenu) => 
    {
        ipcRenderer.sendSync("update-mac-touchbar", {});
    })

    contextBridge.exposeInMainWorld('LR_E_RightClickMenu', (theMenu) => 
    {
        ipcRenderer.sendSync("LR_E_RightClickMenu", theMenu);
    })

    contextBridge.exposeInMainWorld('LR_E_DisableElectronToSendShortCuts', (option) => 
    {
        ipcRenderer.sendSync("LR_E_DisableElectronToSendShortCuts", option);
    })
    
    contextBridge.exposeInMainWorld('LR_E_SetMainWindowTitle', (title) => 
    {
        ipcRenderer.sendSync("LR_E_SetMainWindowTitle", title);
    })

    contextBridge.exposeInMainWorld('LR_E_SetAppMode', (object) => 
    {
        ipcRenderer.sendSync("LR_E_SetAppMode", object);
    })

    ipcRenderer.on("LR_E_SetAppModeReload", (event, arg)=>
    {
        window.location.reload()
    })
}
else if (window.IsIOS)
{
    // eslint-disable-next-line
    ipcRenderer = require("../iosApp/ipcRenderer").ipcRenderer

    window.runAsyncCallBack = function(str) 
    {
        let object = {}
        try
        {
            object = JSON.parse(str)
        }
        catch(e)
        {
            console.error(e)
        }
        
        let called = false;
        let foundIdx = registerdAsyncCallbacks.findIndex( callback =>  
        { 
            if(called === false && callback.id === object.CallbackID && callback.channel === object.Channel)
            {
                callback.func(object.Argument)
                called = true;
                return true
            }
            return false
        })
        if(foundIdx === -1){
            console.error(`Callback with ID ${object.id} not found!`)
        }else{
            registerdAsyncCallbacks.splice(foundIdx, 1)
        }
    }

    window.LR_IOS_EnableRotation = (enable) =>  { enable ?  window.webkit.messageHandlers.EnableOrientation.postMessage("") : window.webkit.messageHandlers.DisableOrientation.postMessage("") }

    window.AsyncOnce = function(channel, func, id) 
    {   
        registerdAsyncCallbacks.push({channel: channel, func: func, id: id})
    }

    window.revolve = function (id, result)
    {
        let callback = callbackMap.get(id)
        if (callback)
        {
            try
            {
                callback(JSON.parse(result));
            }
            catch(e)
            {
                console.log(e)
            }
        }
        callbackMap.delete(id);
    }

    LightRightCall = function (command, object)
    {
        let thisId = callBackid++;
        let req = 
        {
            CallbackId: thisId,
            Command: command,
            Object: object
        };
        window.webkit.messageHandlers.iosCallback.postMessage(JSON.stringify(req));
        return new Promise((res, rej) => { callbackMap.set(thisId, res);  });
    }

    LightRightAsyncCall =  function (command, object)
    {
        let thisId = callBackid++;
        let req = 
        {
            Command: command,
            Object: object
        };
        if(req.Object === undefined){ req.Object = {} }
        req.Object.CallbackID = thisId

        window.webkit.messageHandlers.iosCallbackAsync.postMessage(JSON.stringify(req));
        
        let prom = new Promise((resolve, reject) => 
        {
            
            window.AsyncOnce(command, (arg) => 
            {
                resolve(arg)   
            },
            thisId)
        })

        return prom;
    }

}
else if (window.Android)
{
    // eslint-disable-next-line
    ipcRenderer = require("../iosApp/ipcRenderer").ipcRenderer 

    window.runAsyncCallBack = function(str) 
    {
        let object = {}
        try
        {
            object = JSON.parse(str)
        }
        catch(e)
        {
            console.log(e)
        }
        
        let called = false;
        let foundIdx = registerdAsyncCallbacks.findIndex( callback =>  
        { 
            if(called === false && callback.id === object.CallbackID && callback.channel === object.Channel)
            {
                callback.func(object.Argument)
                called = true;
                return true
            }
            return false
        })
        if(foundIdx === -1){
            console.error(`Callback with ID ${object.id} not found!`)
        }else{
            registerdAsyncCallbacks.splice(foundIdx, 1)
        }

    }

    window.LR_IOS_EnableRotation = (enable) =>  { /* TODO */}

    window.AsyncOnce = function(channel, func, id) 
    {   
        registerdAsyncCallbacks.push({channel: channel, func: func, id: id})
    }

    window.revolve = function (result)
    {
        result = JSON.parse(result)
        let callback = callbackMap.get(result["CallbackId"])
        if (callback)
        {
            callback(result["Object"]);
        }
        callbackMap.delete(result["CallbackId"]);
    }

    LightRightCall = async function (command, object)
    {
        let thisId = callBackid++;
        let req = 
        {
            CallbackId: thisId,
            Command: command,
            Object: object
        };
        let ret = JSON.parse(window.Android.SendMessageSync(JSON.stringify(req)))
        return ret["Object"]
    }

    LightRightAsyncCall =  function (command, object)
    {
        let thisId = callBackid++;
        let req = 
        {
            Command: command,
            Object: object
        };
        if(req.Object === undefined){ req.Object = {} }
        req.Object.CallbackID = thisId

        window.Android.SendMessageAsync(JSON.stringify(req));
        
        let prom = new Promise((resolve, reject) => 
        {
            
            window.AsyncOnce(command, (arg) => 
            {
                resolve(arg)   
            },
            thisId)
        })

        return prom;
    }

}
else if(window.IsVectorworksContext)
{
    // eslint-disable-next-line
    ipcRenderer = require('../vectorworksApp/ipcRenderer').ipcRenderer; 

    window.runAsyncCallBack = function(str_object) 
    {
        let object = {}
        try
        {
            object = JSON.parse(str_object)
        }
        catch(e)
        {
            //window.alert("FAILED " + str_object)
        }
        

        let called = false;
        let foundIdx = registerdAsyncCallbacks.findIndex( callback =>  
        { 
            if(called === false && callback.id === object.CallbackID && callback.channel === object.Channel)
            {
                callback.func(object.Argument)
                called = true;
                return true
            }
            return false
        })
        if(foundIdx === -1){
            console.error(`Callback with ID ${object.id} not found!`)
        }else{
            registerdAsyncCallbacks.splice(foundIdx, 1)
        }

    }
    window.AsyncOnce = function(channel, func, id) 
    {   
        registerdAsyncCallbacks.push({channel: channel, func: func, id: id})
    }

    LightRightAsyncCall =  function(command, object)
    {
        let thisId = callBackid++;
        if(object === undefined){ object = {} }
        object.CallbackID = thisId
        object.CallbackChannel = command
    

        if(window["VW_"+ command]){
            window["VW_"+ command](JSON.stringify(object));
        }else{
            console.error(`Command ${command} does not exsist in VW Context`)
            return
        }

        let prom = new Promise((resolve, reject) => 
        {
            
            window.AsyncOnce(command, (arg) => 
            {
                
                resolve(arg)   
            }, thisId)
        })

        return prom;
    }

    if(window.IsVectorworks2021)
    {
        LightRightCall  = function(command, object)
        {
            let thisId = callBackid++;
            if(object === undefined){ object = {} }
            object.CallbackID = thisId
            object.CallbackChannel = command
            object.VWSYNC           = true
        
    
            if(window["VW_"+ command]){
                window["VW_"+ command](JSON.stringify(object));
            }else{
                console.error(`Command ${command} does not exsist in VW Context`)
                return
            }

            let prom = new Promise((resolve, reject) => 
            {
                
                window.AsyncOnce(command, (arg) => 
                {
                    
                    resolve(arg)   
                }, thisId)
            })
    
            return prom;
        }

    }
    else
    {
        LightRightCall  = function (command, object)
        {
            if(window["VW_"+ command]){
                return JSON.parse(window["VW_"+ command](JSON.stringify(object)) )
            }else{
                console.error(`Command ${command} does not exsist in VW Context`)
                return {}
            }
        }
    }


}
else if(window.IsSketchup)
    {
        // eslint-disable-next-line
        ipcRenderer = require('../vectorworksApp/ipcRenderer').ipcRenderer; 
    
        window.runAsyncCallBack = function(str_object, command, id, sync = false) 
        {
            let object = {}
            try
            {
                object = JSON.parse(str_object)

            }
            catch(e)
            {
                object = {}
                console.error(e)
            }

            if(!command) { command   = object.Channel }
            if(!id)      { id        = Number(object.CallbackID) }
            else         { id = Number(id) }
            
    
            let called = false;
            let foundIdx = registerdAsyncCallbacks.findIndex( callback =>  
            { 
                if(called === false && callback.id === id && callback.channel === command)
                {
                    callback.func(object.Argument ? object.Argument : object)
                    called = true;
                    return true
                }
                return false
            })
            if(foundIdx === -1){
                //window.alert(`Callback with ID ${id} not found!`)
            }else{
                registerdAsyncCallbacks.splice(foundIdx, 1)
            }
    
        }
        window.AsyncOnce = function(channel, func, id) 
        {   
            registerdAsyncCallbacks.push({channel: channel, func: func, id: id})
        }
    
        LightRightAsyncCall =  function(command, object)
        {
            let thisId = callBackid++;
            if(object === undefined){ object = {} }
            object.CallbackID = thisId
            object.CallbackChannel = command
        
    
            if(window.sketchup.SKP_ExecuteAsync){
                window.sketchup.SKP_ExecuteAsync(command,JSON.stringify(object));
            }else{
                return
            }
    
            let prom = new Promise((resolve, reject) => 
            {
                
                window.AsyncOnce(command, (arg) => 
                {
                    
                    resolve(arg)   
                }, thisId)
            })
    
            return prom;
        }
    
        LightRightCall = function(command, object)
        {
            let thisId = callBackid++;
            if(object === undefined){ object = {} }
            object.CallbackID = thisId
            object.CallbackChannel = command
        
    
            if(window.sketchup.SKP_ExecuteSync){
                window.sketchup.SKP_ExecuteSync(command,JSON.stringify(object), thisId);
            }else{
                return
            }
    
            let prom = new Promise((resolve, reject) => 
            {
                window.AsyncOnce(command, (arg) => 
                {       
                    resolve(arg)   
                }, thisId)
            })
    
            return prom;
        }
        
    }
else
{
    // eslint-disable-next-line
    ipcRenderer = require('../webApp/ipcRenderer').ipcRenderer; 
    
    LightRightAsyncCall =  function(command, object)
    {
        if(object === undefined) { object = {} }
        const ret = ipcRenderer.sendAsync(command, object);
        return ret;
    }

    LightRightCall  = function (command, object)
    {
        const ret = ipcRenderer.sendSync(command, object);
        return ret;
    }
}

contextBridge.exposeInMainWorld('LR_SetActiveDrawing', async function (object)  
{
    let result = await LightRightCall("LR_SetActiveDrawing", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetFirstObject', async function (object)  
{
    let result = await LightRightCall("LR_GetFirstObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetFirstChild', async function (object) 
{
    let result = await LightRightCall("LR_GetFirstChild", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetNextObject', async function (object) 
{
    let result = await LightRightCall("LR_GetNextObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetObjectTree', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetObjectTree", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSelectedObjects' , async function(object)
{
    let result = await LightRightCall("LR_GetSelectedObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSelectedObjectCount', async function (object)
{
    let result = await LightRightCall("LR_GetSelectedObjectCount", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddElectricalConnection', async function (object)
{
    let result = await LightRightCall("LR_AddElectricalConnection", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_RemoveElectricalConnection', async function (object)
{
    let result = await LightRightCall("LR_RemoveElectricalConnection", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ClearElectricalConnection', async function (object)
{
    let result = await LightRightCall("LR_ClearElectricalConnection", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddElectricalObjectConnection', async function (object)
{
    let result = await LightRightCall("LR_AddElectricalObjectConnection", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_RemoveElectricalObjectConnection', async function (object)
{
    let result = await LightRightCall("LR_RemoveElectricalObjectConnection", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetDrawings', async function (object) 
{
    let result = await LightRightCall("LR_GetDrawings", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetGeometryTree', async function (object) 
 {
    let result = await LightRightAsyncCall("LR_GetGeometryTree", object);
    return result;
 })

contextBridge.exposeInMainWorld('LR_ReadMVR', async function (object) 
{
    let result = await LightRightCall("LR_ReadMVR", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_WriteMVR', async function (object) 
{
    let result = await LightRightCall("LR_WriteMVR", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SaveFile', async function (object) 
{
    let result = await LightRightCall("LR_SaveFile", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DisableAutosaveTimer', async function (object) 
{
    let result = await LightRightCall("LR_DisableAutosaveTimer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_OpenLRWFile', async function (object) 
{
    let result = await LightRightCall("LR_OpenLRWFile", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetObject', async function (object) 
{
    let result = await LightRightCall("LR_GetObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetObject', async function (object) 
{
    let result = await LightRightCall("LR_SetObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPropertyValue', async function (object) 
{
    let result = await LightRightCall("LR_GetPropertyValue", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetMultipleObjects', async function (object) 
{
    let result = await LightRightCall("LR_SetMultipleObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTableViewGroupingData', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetTableViewGroupingData", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetCalculationPricing', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetCalculationPricing", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_RequestCalculationCheck', async function (object) 
{
    let result = await LightRightAsyncCall("LR_RequestCalculationCheck", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_RequestCalculationQuote', async function (object) 
{
    let result = await LightRightAsyncCall("LR_RequestCalculationQuote", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetInventoryData', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetInventoryData", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetInventorySummery', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetInventorySummery", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetObjectProperties', async function (object)  
{
    let result = await LightRightAsyncCall("LR_GetObjectProperties", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSigningJob', async function (object)  
{
    let result = await LightRightAsyncCall("LR_GetSigningJob", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_UpdateSigningJob', async function (object)  
{
    let result = await LightRightAsyncCall("LR_UpdateSigningJob", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetObjectProperties', async function (object) 
{
    let result = await LightRightCall("LR_SetObjectProperties", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewObject', async function (object) 
{
    let result = await LightRightCall("LR_AddNewObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewPreset', async function (object)
{
    let result = await LightRightCall("LR_AddNewPreset", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeletePreset', async function (object) 
{
    let result = await LightRightCall("LR_DeletePreset", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPresets', async function (object) 
{
    let result = await LightRightCall("LR_GetPresets", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetPreset', async function (object) 
{
    let result = await LightRightCall("LR_SetPreset", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetEditablePreset', async function (object)
{
    let result = await LightRightCall("LR_SetEditablePreset", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetActivePreset', async function (object)
{
    let result = await LightRightCall("LR_SetActivePreset", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetPresetOrder', async function (object)
{
    let result = await LightRightCall("LR_SetPresetOrder", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeactivatePresets', async function (object)
{
    let result = await LightRightCall("LR_DeactivatePresets", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSceneTreeFilterState', async function (object)
{
    let result = await LightRightCall("LR_GetSceneTreeFilterState", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetSceneTreeFilterState', async function (object)
{
    let result = await LightRightCall("LR_SetSceneTreeFilterState", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_RemovePresetEntry', async function (object)
{
    let result = await LightRightCall("LR_RemovePresetEntry", object);
    return result;
})
//-----------------------------------------------------------------------------------------
// Complete Objects

contextBridge.exposeInMainWorld('LR_GetCompleteObject', async function (object)
{
    let result = await LightRightCall("LR_GetCompleteObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSelectiveObject', async function (object)
{
    let result = await LightRightAsyncCall("LR_GetSelectiveObject", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_GetCompleteFirstObject', async function (object) 
{
    let result = await LightRightCall("LR_GetCompleteFirstObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetCompleteFirstChild', async function (object)
{
    let result = await LightRightCall("LR_GetCompleteFirstChild", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetCompleteNextObject', async function (object)
{
    let result = await LightRightCall("LR_GetCompleteNextObject", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Geometry

contextBridge.exposeInMainWorld('LR_GetFirstChildGeometry', async function (object) 
{
    let result = await LightRightCall("LR_GetFirstChildGeometry", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetNextGeometry', async function (object) 
{
    let result = await LightRightCall("LR_GetNextGeometry", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetGeometry', async function (object) 
{
    let result = await LightRightCall("LR_GetGeometry", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetGeometryTransformFromObject', async function (object) 
{
    let result = await LightRightCall("LR_GetGeometryTransformFromObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetGeometry', async function (object) 
{
    let result = await LightRightCall("LR_SetGeometry", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetGeometryDefiningResource', async function (object) 
{
    let result = await LightRightCall("LR_SetGeometryDefiningResource", object);
    return result;
})

//-----------------------------------------------------------------------------------------

contextBridge.exposeInMainWorld('LR_Select', async function (object) 
{
    let result = await LightRightCall("LR_Select", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SelectAll', async function (object) 
{
    let result = await LightRightCall("LR_SelectAll", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SelectPrev', async function (object) 
{
    let result = await LightRightCall("LR_SelectPrev", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SelectNext', async function (object) 
{
    let result = await LightRightCall("LR_SelectNext", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SelectUp', async function (object) 
{
    let result = await LightRightCall("LR_SelectUp", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SelectDown', async function (object) 
{
    let result = await LightRightCall("LR_SelectDown", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_MoveSelectedUp', async function (object)
{
    let result = await LightRightCall("LR_MoveSelectedUp", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_MoveSelectedDown', async function (object)
{
    let result = await LightRightCall("LR_MoveSelectedDown", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SelectChildren', async function (object) 
{
    let result = await LightRightCall("LR_SelectChildren", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CollapseChildren', async function (object) 
{
    let result = await LightRightCall("LR_CollapseChildren", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_LRNETSendPing', async function (object) 
{
    let result = await LightRightCall("LR_LRNETSendPing", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DoUndo', async function (object) 
{
    let result = await LightRightCall("LR_DoUndo", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DoRedo', async function (object) 
{
    let result = await LightRightCall("LR_DoRedo", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ExpandAll', async function (object) 
{
    let result = await LightRightCall("LR_ExpandAll", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GroupSelected', async function (object) 
{
    let result = await LightRightCall("LR_GroupSelected", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DisolveGroup', async function (object) 
{
    let result = await LightRightCall("LR_DisolveGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_PatchSelectedObjects', async function (object) 
{
    let result = await LightRightCall("LR_PatchSelectedObjects", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Align

contextBridge.exposeInMainWorld('LR_AlignOn', async function (object)
{
    let result = await LightRightCall("LR_AlignOn", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ShowModalDialog', async function (object) 
{
    let result = await LightRightCall("LR_ShowModalDialog", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTrussCrossSectionByName', async function (object) 
{
    let result = await LightRightCall("LR_GetTrussCrossSectionByName", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetAlignedValue', async function (object) 
{
    let result = await LightRightCall("LR_SetAlignedValue", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Change Hierarchy

contextBridge.exposeInMainWorld('LR_SetChild', async function (object) 
{
    let result = await LightRightCall("LR_SetChild", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetNext', async function (object)
{
    let result = await LightRightCall("LR_SetNext", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetPrev', async function (object)
{
    let result = await LightRightCall("LR_SetPrev", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Server 

contextBridge.exposeInMainWorld('LR_CommitApprovedChanges', async function (object) 
{
    let result = await LightRightCall("LR_CommitApprovedChanges", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_UpdateApprovedChanges', async function (object) 
{
    let result = await LightRightCall("LR_UpdateApprovedChanges", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Worksheet

contextBridge.exposeInMainWorld('LR_CreateAssemblySheetsForGroups', async function (object) 
{
    let result = await LightRightCall("LR_CreateAssemblySheetsForGroups", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewWorksheet', async function (object) 
{
    let result = await LightRightCall("LR_AddNewWorksheet", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteWorksheet', async function (object) 
{
    let result = await LightRightCall("LR_DeleteWorksheet", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetWorksheets', async function (object)  
{
    let result = await LightRightCall("LR_GetWorksheets", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetWorksheetObjects', async function (object)  
{
    let result = await LightRightAsyncCall("LR_GetWorksheetObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetWorksheet', async function (object) 
{
    let result = await LightRightCall("LR_SetWorksheet", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetWorksheetOrder', async function (object)
{
    let result = await LightRightCall("LR_SetWorksheetOrder", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetWorksheetActivePresets', async function (object)
{
    let result = await LightRightCall("LR_GetWorksheetActivePresets", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetProjectTasks' , async function()
{
    let result = await LightRightAsyncCall("LR_GetProjectTasks")
    return result
})

contextBridge.exposeInMainWorld('LR_GetWorksheetTasks' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetWorksheetTasks", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SwitchTaskState' , async function(object)
{
    let result = await LightRightAsyncCall("LR_SwitchTaskState", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetProjectSettings' , async function(object)
{
    let result = await LightRightCall("LR_GetProjectSettings", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetProjectSettings', async function (object)
{
    let result = await LightRightCall("LR_SetProjectSettings", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Layer

contextBridge.exposeInMainWorld('LR_AddNewLayer', async function (object) 
{
    let result = await LightRightCall("LR_AddNewLayer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteLayer', async function (object) 
{
    let result = await LightRightCall("LR_DeleteLayer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteLayers', async function (object) 
{
    let result = await LightRightCall("LR_DeleteLayers", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_GetLayer', async function (object)  
{
    let result = await LightRightCall("LR_GetLayer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetLayers', async function (object)  
{
    let result = await LightRightCall("LR_GetLayers", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetLayer', async function (object) 
{
    let result = await LightRightCall("LR_SetLayer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetLayers', async function (object) 
{
    let result = await LightRightAsyncCall("LR_SetLayers", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetActiveLayer', async function (object) 
{
    let result = await LightRightCall("LR_GetActiveLayer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetActiveLayer', async function (object) 
{
    let result = await LightRightCall("LR_SetActiveLayer", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Class

contextBridge.exposeInMainWorld('LR_AddNewClass', async function (object) 
{
    let result = await LightRightCall("LR_AddNewClass", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteClass', async function (object) 
{
    let result = await LightRightCall("LR_DeleteClass", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteClasses', async function (object) 
{
    let result = await LightRightCall("LR_DeleteClasses", object);
    return result;

})

contextBridge.exposeInMainWorld('LR_GetClass', async function (object)  
{
    let result = await LightRightCall("LR_GetClass", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetClasses', async function (object)  
{
    let result = await LightRightCall("LR_GetClasses", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetClass', async function (object) 
{
    let result = await LightRightCall("LR_SetClass", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetClasses', async function (object) 
{
    let result = await LightRightAsyncCall("LR_SetClasses", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetActiveClass', async function (object) 
{
    let result = await LightRightCall("LR_GetActiveClass", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetActiveClass', async function (object) 
{
    let result = await LightRightCall("LR_SetActiveClass", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Selection Group

contextBridge.exposeInMainWorld('LR_AddNewSelectionGroup', async function (object)
{
    let result = await LightRightCall("LR_AddNewSelectionGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddSelectionGroupForFixturesInLine', async function (object)
{
    let result = await LightRightCall("LR_AddSelectionGroupForFixturesInLine", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteSelectionGroup', async function (object)
{
    let result = await LightRightCall("LR_DeleteSelectionGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSelectionGroups', async function (object)
{
    let result = await LightRightCall("LR_GetSelectionGroups", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddObjectToSelectionGroup', async function (object)
{
    let result = await LightRightCall("LR_AddObjectToSelectionGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetSelectionGroup', async function (object)
{
    let result = await LightRightCall("LR_SetSelectionGroup", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Inventory Container

contextBridge.exposeInMainWorld('LR_AddNewTruck', async function (object)
{
    let result = await LightRightCall("LR_AddNewTruck", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteTruck', async function (object)
{
    let result = await LightRightCall("LR_DeleteTruck", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTrucks', async function (object)
{
    let result = await LightRightCall("LR_GetTrucks", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTruck', async function (object)
{
    let result = await LightRightCall("LR_GetTruck", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTruckObjects', async function (object)
{
    let result = await LightRightAsyncCall("LR_GetTruckObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetTruck', async function (object)
{
    let result = await LightRightCall("LR_SetTruck", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Cases

contextBridge.exposeInMainWorld('LR_AddNewCase', async function (object)
{
    let result = await LightRightCall("LR_AddNewCase", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetCases', async function (object)
{
    let result = await LightRightCall("LR_GetCases", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetCase', async function (object)
{
    let result = await LightRightCall("LR_SetCase", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteCase', async function (object)
{
    let result = await LightRightCall("LR_DeleteCase", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Resource Manager

contextBridge.exposeInMainWorld('LR_GetExternalDocuments', async function (object)  
{
    let result = await LightRightCall("LR_GetExternalDocuments", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteExternalDocument', async function (object)  
{
    let result = await LightRightCall("LR_DeleteExternalDocument", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSingleTexture', async function (object)  
{
    let result = await LightRightAsyncCall("LR_GetSingleTexture", {...object, Async: true});
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTextures', async function (object)  
{
    let result = await LightRightAsyncCall("LR_GetTextures", {...object, Async: true});
    return result;
})

contextBridge.exposeInMainWorld('LR_GetMeshes', async function (object)  
{
    let result = await LightRightCall("LR_GetMeshes", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetMeshesForResources', async function (object)  
{
    let result = await LightRightCall("LR_GetMeshesForResources", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetFixtureTypes', async function (object)  
{
    let result = await LightRightCall("LR_GetFixtureTypes", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetFixtureTypesFromObject', async function (object)  
{
    let result = await LightRightCall("LR_GetFixtureTypesFromObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetFixtureTypes', async function (object)  
{
    let result = await LightRightCall("LR_SetFixtureTypes", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_NumberAllFixtures', async function (object)  
{
    let result = await LightRightCall("LR_NumberAllFixtures", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewSymbolDefinition', async function (object)
{
    let result = await LightRightCall("LR_AddNewSymbolDefinition", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSymbolDefs', async function (object)  
{
    let result = await LightRightCall("LR_GetSymbolDefs", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetLocaleResources' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetLocaleResources", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetServerResources' , async function(object)
{
    let result = await LightRightCall("LR_GetServerResources", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ImportRessource' , async function(object)
{
    let result = await LightRightCall("LR_ImportRessource", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ImportPrintLabel' , async function(object)
{
    let result = await LightRightCall("LR_ImportPrintLabel", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ImportServerResourceAsync' , async function(object)
{
    let result = await LightRightAsyncCall("LR_ImportServerResourceAsync", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CacheServerResourceAsync' , async function(object)
{
    let result = await LightRightAsyncCall("LR_CacheServerResourceAsync", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CreateResourceCategoryOnServer' , async function(object)
{
    let result = await LightRightAsyncCall("LR_CreateResourceCategoryOnServer", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_UploadSingleResourceToServerAsync' , async function(object)
{
    let result = await LightRightAsyncCall("LR_UploadSingleResourceToServerAsync", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ImportMesh' , async function(object)
{
    let result = await LightRightCall("LR_ImportMesh", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ImportTexture' , async function(object)
{
    let result = await LightRightCall("LR_ImportTexture", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ImportGdtf' , async function(object)
{
    let result = await LightRightCall("LR_ImportGdtf", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ImportExternalDocument' , async function(object)
{
    let result = await LightRightCall("LR_ImportExternalDocument", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetResourceFile', async function (object)
{
    let result = await LightRightCall("LR_GetResourceFile", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetElectricalObjects', async function (object)
{
    let result = await LightRightAsyncCall("LR_GetElectricalObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetElectricalGeometries', async function (object)
{
    let result = await LightRightAsyncCall("LR_GetElectricalGeometries", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetCurrentElectricalTree' , async function(object)
{
    let result = await LightRightCall("LR_GetCurrentElectricalTree", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetDmxTree' , async function(object)
{
    let result = await LightRightCall("LR_GetDmxTree", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetCurrentSimpleElectricalTree' , async function(object)
{
    let result = await LightRightCall("LR_GetCurrentSimpleElectricalTree", object);
    return result;
})

//-----------------------------------------------------------------------------------------
// Time Phase

contextBridge.exposeInMainWorld('LR_AddNewTimePhase', async function (object)  
{
    let result = await LightRightCall("LR_AddNewTimePhase", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteTimePhase', async function (object) 
{
    let result = await LightRightCall("LR_DeleteTimePhase", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTimePhases', async function (object)  
{
    let result = await LightRightCall("LR_GetTimePhases", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetTimePhase', async function (object) 
{
    let result = await LightRightCall("LR_SetTimePhase", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetTimePhaseOrder', async function (object)
{
    let result = await LightRightCall("LR_SetTimePhaseOrder", object);
    return result;
})


// Time Phase Change

contextBridge.exposeInMainWorld('LR_AddNewTimePhaseChange', async function (object) 
{
    let result = await LightRightCall("LR_AddNewTimePhaseChange", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteTimePhaseChange', async function (object) 
{
    let result = await LightRightCall("LR_DeleteTimePhaseChange", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetTimePhaseChange', async function (object) 
{
    let result = await LightRightCall("LR_SetTimePhaseChange", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetTimePhaseChangeOrder', async function (object)
{
    let result = await LightRightCall("LR_SetTimePhaseChangeOrder", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetNeededTimeFromPhase', async function (object)
{
    let result = await LightRightCall("LR_GetNeededTimeFromPhase", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTimePhaseChanges', async function (object)
{
    let result = await LightRightCall("LR_GetTimePhaseChanges", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTimePhaseChange', async function (object)
{
    let result = await LightRightCall("LR_GetTimePhaseChange", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_PlayTimelineUntil', async function (object)
{
    let result = await LightRightCall("LR_PlayTimelineUntil", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ResetHighlight', async function (object)
{
    let result = await LightRightCall("LR_ResetHighlight", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetDefaultFixtureType', async function (object) 
{
    let result = await LightRightCall("LR_SetDefaultFixtureType", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewDmxMode', async function (object) 
{
    let result = await LightRightCall("LR_AddNewDmxMode", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetDefaultMesh', async function (object) 
{
    let result = await LightRightCall("LR_SetDefaultMesh", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DuplicateObject', async function (object) 
{
    let result = await LightRightCall("LR_DuplicateObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_OpenGeometryEditMode', async function (object) 
{
    let result = await LightRightCall("LR_OpenGeometryEditMode", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CloseGeometryEditMode', async function (object) 
{
    let result = await LightRightCall("LR_CloseGeometryEditMode", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetGeometryEditMode', async function (object)
{
    let result = await LightRightCall("LR_GetGeometryEditMode", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_OpenPolygonRendererViewEditMode', async function (object)
{
    let result = await LightRightCall("LR_OpenPolygonRendererViewEditMode", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ClosePolygonRendererViewEditMode', async function (object)
{
    let result = await LightRightCall("LR_ClosePolygonRendererViewEditMode", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPolygonRendererViewEditMode', async function (object)
{
    let result = await LightRightCall("LR_GetPolygonRendererViewEditMode", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_PlaceToStructure' , async function(object)
{
    let result = await LightRightCall("LR_PlaceToStructure", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_RunPlaceToStructure', async function (object)
{
    let result = await LightRightCall("LR_RunPlaceToStructure", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetLinkedProject' , async function(object)  
{
    let result = await LightRightCall("LR_GetLinkedProject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ReplaceSelectedFixtureTypes', async function (object)  
{
    let result = await LightRightCall("LR_ReplaceSelectedFixtureTypes", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ReplaceSelectedSymbolDefinition', async function (object)  
{
    let result = await LightRightCall("LR_ReplaceSelectedSymbolDefinition", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ValidateToken', async function (object)  
{
    let result = await LightRightCall("LR_ValidateToken", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CloseLRWFile', async function (object)  
{
    let result = await LightRightCall("LR_CloseLRWFile", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_LogOutFromServer', async function (object)  
{
    let result = await LightRightCall("LR_LogOutFromServer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_LoginToServerAsync', async function (object)  
{
    let result = await LightRightAsyncCall("LR_LoginToServerAsync", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_LoginToServerSSOAsync', async function (object)  
{
    let result = await LightRightAsyncCall("LR_LoginToServerSSOAsync", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DuplicateSelectedObject', async function (object)  
{
    let result = await LightRightCall("LR_DuplicateSelectedObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DuplicateSelectedObjectXYZ', async function (object)  
{
    let result = await LightRightCall("LR_DuplicateSelectedObjectXYZ", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_DeleteObject', async function (object)
{
    let result = await LightRightCall("LR_DeleteObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteSelectedObjects', async function (object)  
{
    let result = await LightRightCall("LR_DeleteSelectedObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteObjects', async function (object)  
{
    let result = await LightRightCall("LR_DeleteObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetServerResourceAsync', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetServerResourceAsync", object);
    return result
})

contextBridge.exposeInMainWorld('LR_GetServerResourceCached', async function (object) 
{
    let result = await LightRightCall("LR_GetServerResourceCached", object);
    return result
})

contextBridge.exposeInMainWorld('LR_GetCachedResources', async function (object) 
{
    let result = await LightRightCall("LR_GetCachedResources", object);
    return result
})

contextBridge.exposeInMainWorld('LR_GetProjectsAsync', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetProjectsAsync", object);
    return result
})


contextBridge.exposeInMainWorld('LR_GetCollaboratorsAsync', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetCollaboratorsAsync", object);
    return result
})

contextBridge.exposeInMainWorld('LR_GetOrganizationsAsync', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetOrganizationsAsync", object);
    return result
})

contextBridge.exposeInMainWorld('LR_GetUserDataAsync', async function (object) 
{
    let result = await LightRightAsyncCall("LR_GetUserDataAsync", object);
    return result
})


contextBridge.exposeInMainWorld('LR_SetDefaultSymbolDef', async function (object)
{
    let result = await LightRightCall("LR_SetDefaultSymbolDef", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetLinkedProject', async function (object) 
{
    let result = await LightRightCall("LR_SetLinkedProject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CommitToServer', async function (object) 
{
    let result = await LightRightCall("LR_CommitToServer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_UpdateFromServer', async function (object) 
{
    let result = await LightRightCall("LR_UpdateFromServer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CreateNewDrawing', async function (object) 
{
    let result = await LightRightCall("LR_CreateNewDrawing", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ShowConnectToRemote', async function (object) 
{
    let result = await LightRightCall("LR_ShowConnectToRemote", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ShowVRDialog', async function (object) 
{
    let result = await LightRightCall("LR_ShowVRDialog", object);
    return result;
})
contextBridge.exposeInMainWorld('LR_ShowAboutDialog', async function (object) 
{
    let result = await LightRightCall("LR_ShowAboutDialog", object);
    return result;
})
contextBridge.exposeInMainWorld('LR_ShowStructuralWizard', async function (object) 
{
    let result = await LightRightCall("LR_ShowStructuralWizard", object);
    return result;
})
contextBridge.exposeInMainWorld('LR_RunStructuralWizard', async function (object) 
{
    let result = await LightRightCall("LR_RunStructuralWizard", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetVersionInfo', async function (object) 
{
    let result = await LightRightCall("LR_GetVersionInfo", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ConnectToRemote', async function (object) 
{
    let result = await LightRightCall("LR_ConnectToRemote", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_CreateNewProjectAsync', async function (object) 
{
    let result = await LightRightAsyncCall("LR_CreateNewProjectAsync", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetLoggedInUser', async function (object) 
{
    let result = await LightRightCall("LR_GetLoggedInUser", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetRecentFiles', async function (object)
{
    let result = await LightRightCall("LR_GetRecentFiles", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_OpenRecentChecked', async function (object)
{
    let result = await LightRightCall("LR_OpenRecentChecked", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ZoomToSelection', async function (object) 
{
    let result = await LightRightCall("LR_ZoomToSelection", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetRendererView', async function (object) 
{
    let result = await LightRightCall("LR_SetRendererView", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ArrangeSelectedObjects', async function (object) 
{
    let result = await LightRightCall("LR_ArrangeSelectedObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetSymbolDef', async function (object)
{
    let result = await LightRightCall("LR_SetSymbolDef", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetMesh', async function (object)
{
    let result = await LightRightCall("LR_SetMesh", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTimeLineStepData', async function (object)
{
    let result = await LightRightAsyncCall("LR_GetTimeLineStepData", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_PatchChildObjects', async function (object) 
{
    let result = await LightRightCall("LR_PatchChildObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetMesh', async function (object)
{
    let result = await LightRightCall("LR_GetMesh", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddObjectArray', async function (object)
{
    let result = await LightRightCall("LR_AddObjectArray", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetObjectArray', async function (object)
{
    let result = await LightRightCall("LR_SetObjectArray", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_PasteObject', async function (object)
{
    let result = await LightRightCall("LR_PasteObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CutObject', async function (object)
{
    let result = await LightRightCall("LR_CutObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CopyObject', async function (object)
{
    let result = await LightRightCall("LR_CopyObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ReadMa3Cue', async function (object)
{
    let result = await LightRightCall("LR_ReadMa3Cue", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetStructures', async function (object)
{
    let result = await LightRightCall("LR_GetStructures", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetStructuresRaw', async function (object)
{
    let result = await LightRightCall("LR_GetStructuresRaw", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SelectConnectedStructure', async function (object)
{
    let result = await LightRightCall("LR_SelectConnectedStructure", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPresetContent', async function (object)
{
    let result = await LightRightCall("LR_GetPresetContent", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetAllPresetsContent', async function (object)
{
    let result = await LightRightCall("LR_GetAllPresetsContent", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetAllActiveFixtures', async function (object)
{
    let result = await LightRightCall("LR_GetAllActiveFixtures", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetFixturesByAlignment', async function (object)
{
    let result = await LightRightCall("LR_GetFixturesByAlignment", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetGlobalSettings', async function (object)
{
    let result = await LightRightCall("LR_GetGlobalSettings", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetGlobalSettings', async function (object)
{
    let result = await LightRightCall("LR_SetGlobalSettings", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_RunOpenSettings', async function (object)
{
    let result = await LightRightCall("LR_RunOpenSettings", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ListenToMA3DMX', async function (object)
{
    let result = await LightRightCall("LR_ListenToMA3DMX", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_StopListenToMA3DMX', async function (object)
{
    let result = await LightRightCall("LR_StopListenToMA3DMX", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetDataForDMXUniverse', async function (object)
{
    let result = await LightRightAsyncCall("LR_GetDataForDMXUniverse", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CheckoutProject', async function (object)
{
    let result = await LightRightAsyncCall("LR_CheckoutProject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSupportList', async function (object)
{
    let result = await LightRightCall("LR_GetSupportList", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewPrintLabel', async function (object)
{
    let result = await LightRightCall("LR_AddNewPrintLabel", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPrintLabels', async function (object)
{
    let result = await LightRightCall("LR_GetPrintLabels", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_DeletePrintLabel', async function (object)
{
    let result = await LightRightCall("LR_DeletePrintLabel", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_GetPrintLabel', async function (object)
{
    let result = await LightRightCall("LR_GetPrintLabel", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetPrintLabel', async function (object)
{
    let result = await LightRightCall("LR_SetPrintLabel", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetPrintLabelFields', async function (object)
{
    let result = await LightRightCall("LR_SetPrintLabelFields", object);
    return result;
})
 
contextBridge.exposeInMainWorld('LR_PrintLabels', async function (object)
{
    let result = await LightRightCall("LR_PrintLabels", object);
    return result;
})  

contextBridge.exposeInMainWorld('LR_SelectPrintLabelField', async function (object)
{
    let result = await LightRightCall("LR_SelectPrintLabelField", object);
    return result;
})  

contextBridge.exposeInMainWorld('LR_ResetSelectedLabelFields', async function (object)
{
    let result = await LightRightCall("LR_ResetSelectedLabelFields", object);
    return result;
})  

contextBridge.exposeInMainWorld('LR_SetPaperFormatTemplate', async function (object)
{
    let result = await LightRightCall("LR_SetPaperFormatTemplate", object);
    return result;
})  
contextBridge.exposeInMainWorld('LR_GetPaperFormatTemplateMap', async function (object)
{
    let result = await LightRightCall("LR_GetPaperFormatTemplateMap", object);
    return result;
})  
contextBridge.exposeInMainWorld('LR_AddPaperFormatTemplate', async function (object)
{
    let result = await LightRightCall("LR_AddPaperFormatTemplate", object);
    return result;
})  
contextBridge.exposeInMainWorld('LR_DeletePaperFormatTemplate', async function (object)
{
    let result = await LightRightCall("LR_DeletePaperFormatTemplate", object);
    return result;
})  

contextBridge.exposeInMainWorld('LR_UsePaperFormatTemplate', async function (object)
{
    let result = await LightRightCall("LR_UsePaperFormatTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetPrintFormatTemplate', async function (object)
{
    let result = await LightRightCall("LR_SetPrintFormatTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddPrintFormatTemplate', async function (object)
{
    let result = await LightRightCall("LR_AddPrintFormatTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPrintFormatTemplateMap', async function (object)
{
    let result = await LightRightCall("LR_GetPrintFormatTemplateMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeletePrintFormatTemplate', async function (object)
{
    let result = await LightRightCall("LR_DeletePrintFormatTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSetSelectedPrintFormatTemplate', async function (object)
{
    let result = await LightRightCall("LR_GetSetSelectedPrintFormatTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSummeryList', async function (object)
{
    let result = await LightRightCall("LR_GetSummeryList", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSymbolMap', async function (object)
{
    let result = await LightRightCall("LR_GetSymbolMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteSymbolMap', async function (object)
{
    let result = await LightRightCall("LR_DeleteSymbolMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddSymbolMap', async function (object)
{
    let result = await LightRightCall("LR_AddSymbolMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetSymbolMapTemplate' , async function(object)
{
    let result = await LightRightCall("LR_SetSymbolMapTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_NewSymbolMapTemplate' , async function(object)
{
    let result = await LightRightCall("LR_NewSymbolMapTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSymbolMapTemplates' , async function(object)
{
    let result = await LightRightCall("LR_GetSymbolMapTemplates", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteSymbolMapTemplate' , async function(object)
{
    let result = await LightRightCall("LR_DeleteSymbolMapTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_UpdateFromSymbolMapTemplate', async function(object)
{
    let result = await LightRightCall("LR_UpdateFromSymbolMapTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddTruckTemplate', async function (object)
{
    let result = await LightRightCall("LR_AddTruckTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteTruckTemplate', async function (object)
{
    let result = await LightRightCall("LR_DeleteTruckTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTruckTemplateMap', async function (object)
{
    let result = await LightRightCall("LR_GetTruckTemplateMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetTruckTemplate', async function (object)
{
    let result = await LightRightCall("LR_SetTruckTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddCaseTemplate', async function (object)
{
    let result = await LightRightCall("LR_AddCaseTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteCaseTemplate', async function (object)
{
    let result = await LightRightCall("LR_DeleteCaseTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteRackTemplate', async function (object)
{
    let result = await LightRightCall("LR_DeleteRackTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddCaseTemplateSymbol', async function (object)
{
    let result = await LightRightCall("LR_AddCaseTemplateSymbol", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_RemoveCaseTemplateSymbol', async function (object)
{
    let result = await LightRightCall("LR_RemoveCaseTemplateSymbol", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetCaseTemplateSymbols', async function (object)
{
    let result = await LightRightCall("LR_SetCaseTemplateSymbols", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetCaseTemplateMap', async function (object)
{
    let result = await LightRightCall("LR_GetCaseTemplateMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetRackTemplate', async function (object)
{
    let result = await LightRightCall("LR_SetRackTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddRackTemplate', async function (object)
{
    let result = await LightRightCall("LR_AddRackTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetRackTemplateMap', async function (object)
{
    let result = await LightRightCall("LR_GetRackTemplateMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPropertyTemplateMap', async function (object)
{
    let result = await LightRightCall("LR_GetPropertyTemplateMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_WorksheetFilterHelper', async function (object)
{
    let result = await LightRightAsyncCall("LR_WorksheetFilterHelper", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPropertyTemplate', async function (object)
{
    let result = await LightRightCall("LR_GetPropertyTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddPropertyTemplate', async function (object)
{
    let result = await LightRightCall("LR_AddPropertyTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeletePropertyTemplate', async function (object)
{
    let result = await LightRightCall("LR_DeletePropertyTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetPropertyTemplate', async function (object)
{
    let result = await LightRightCall("LR_SetPropertyTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetInventoryPropertyTemplateMap', async function (object)
{
    let result = await LightRightCall("LR_GetInventoryPropertyTemplateMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetInventoryPropertyTemplate', async function (object)
{
    let result = await LightRightCall("LR_GetInventoryPropertyTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddInventoryPropertyTemplate', async function (object)
{
    let result = await LightRightCall("LR_AddInventoryPropertyTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetInventoryPropertyTemplate', async function (object)
{
    let result = await LightRightCall("LR_SetInventoryPropertyTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetConnectors_Data', async function (object)
{
    let result = await LightRightCall("LR_GetConnectors_Data", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetConnectors_Electric', async function (object)
{
    let result = await LightRightCall("LR_GetConnectors_Electric", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewColorCodeObject', async function (object)
{
    let result = await LightRightCall("LR_AddNewColorCodeObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetColorCodeObjects', async function (object)
{
    let result = await LightRightCall("LR_GetColorCodeObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetColorCodeObject', async function (object)
{
    let result = await LightRightCall("LR_SetColorCodeObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteColorCodeObject', async function (object)
{
    let result = await LightRightCall("LR_DeleteColorCodeObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetColorCodeObject', async function (object)
{
    let result = await LightRightCall("LR_GetColorCodeObject", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewDepartment', async function (object)
{
    let result = await LightRightCall("LR_AddNewDepartment", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetDepartments', async function (object)
{
    let result = await LightRightCall("LR_GetDepartments", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetDepartment', async function (object)
{
    let result = await LightRightCall("LR_GetDepartment", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteDepartment', async function (object)
{
    let result = await LightRightCall("LR_DeleteDepartment", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetDepartment', async function (object)
{
    let result = await LightRightCall("LR_SetDepartment", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DataPatchSelectedObjects', async function (object)
{
    let result = await LightRightCall("LR_DataPatchSelectedObjects", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_DataPatchChildObjects', async function (object)
{
    let result = await LightRightCall("LR_DataPatchChildObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_OpenChangeOrigin', async function (object)
{
    let result = await LightRightCall("LR_OpenChangeOrigin", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ChangeOrigin', async function (object)
{
    let result = await LightRightCall("LR_ChangeOrigin", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CommandLine', async function (object)
{
    let result = await LightRightCall("LR_CommandLine", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_OpenCurrentOnline', async function (object)
{
    let result = await LightRightCall("LR_OpenCurrentOnline", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetAssemblyGroups', async function (object)
{
    let result = await LightRightCall("LR_GetAssemblyGroups", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_MoveToAssemblyGroup', async function (object)
{
    let result = await LightRightCall("LR_MoveToAssemblyGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetInventoryContainerOptions', async function (object)
{
    let result = await LightRightCall("LR_GetInventoryContainerOptions", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_OpenFixtureNumbering', async function (object)
{
    let result = await LightRightCall("LR_OpenFixtureNumbering", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ImportFixtureType', async function (object)
{
    let result = await LightRightCall("LR_ImportFixtureType", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewRack', async function (object)
{
    let result = await LightRightCall("LR_AddNewRack", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetRacks', async function (object)
{
    let result = await LightRightCall("LR_GetRacks", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetRack', async function (object)
{
    let result = await LightRightCall("LR_SetRack", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteRack', async function (object)
{
    let result = await LightRightCall("LR_DeleteRack", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_PackObjectsIntoContainer', async function (object)
{
    let result = await LightRightCall("LR_PackObjectsIntoContainer", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetProjectDataAsync', async function (object)
{
    let result = await LightRightAsyncCall("LR_GetProjectDataAsync", object);
    return result
})

contextBridge.exposeInMainWorld('LR_SortFixtureByProperty', async function (object)
{
    let result = await LightRightCall("LR_SortFixtureByProperty", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetGenerators', async function (object)
{
    let result = await LightRightCall("LR_GetGenerators", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_Test', async function (object)
{
    let result = await LightRightCall("LR_Test", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_UpdateCaseTemplate', async function (object)
{
    let result = await LightRightCall("LR_UpdateCaseTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ValidateUserNameAsync', async function (object) 
{
    let result = await LightRightAsyncCall("LR_ValidateUserNameAsync", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewObject_Line', async function (object)
{
    let result = await LightRightCall("LR_AddNewObject_Line", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetVWFieldMap', async function (object)
{
    let result = await LightRightCall("LR_GetVWFieldMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddVWFieldMap', async function (object)
{
    let result = await LightRightCall("LR_AddVWFieldMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteVWFieldMap', async function (object)
{
    let result = await LightRightCall("LR_DeleteVWFieldMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_UpdateVWFieldMap', async function (object)
{
    let result = await LightRightCall("LR_UpdateVWFieldMap", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPossibleFields', async function (object)
{
    let result = await LightRightCall("LR_GetPossibleFields", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPossibleFieldsCases', async function (object)
{
    let result = await LightRightCall("LR_GetPossibleFieldsCases", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPossibleFieldsRacks', async function (object)
{
    let result = await LightRightCall("LR_GetPossibleFieldsRacks", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetPossibleFieldsGeometry', async function (object)
{
    let result = await LightRightCall("LR_GetPossibleFieldsGeometry", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetLocalPlugInFields', async function (object)
{
    let result = await LightRightCall("LR_GetLocalPlugInFields", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_SortFixturesByPositionOnStruct', async function (object)
{
    let result = await LightRightCall("LR_SortFixturesByPositionOnStruct", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetDefiningResourceGeometry', async function (object)
{
    let result = await LightRightCall("LR_SetDefiningResourceGeometry", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetDrawingWorksheetState', async function (object)
{
    let result = await LightRightCall("LR_GetDrawingWorksheetState", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetEditModeWorksheetState', async function (object)
{
    let result = await LightRightCall("LR_GetEditModeWorksheetState", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetCellData', async function (object)
{
    let result = await LightRightCall("LR_SetCellData", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetCellState', async function (object)
{
    let result = await LightRightCall("LR_GetCellState", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetDrawingWorksheetState', async function (object)
{
    let result = await LightRightCall("LR_SetDrawingWorksheetState", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CreateBranchAsync', async function (object)
{
    let result = await LightRightAsyncCall("LR_CreateBranchAsync", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetAppDisplayState', async function (object)
{
    let result = await LightRightCall("LR_GetAppDisplayState", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetAppDisplayState', async function (object)
{
    let result = await LightRightCall("LR_SetAppDisplayState", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetGelList', async function (object)
{
    let result = await LightRightCall("LR_GetGelList", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetGelRolls', async function (object)
{
    let result = await LightRightCall("LR_GetGelRolls", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CreateGroupsByProperty', async function (object)
{
    let result = await LightRightCall("LR_CreateGroupsByProperty", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetDuplicatedFixtureIDs', async function (object)
{
    let result = await LightRightCall("LR_GetDuplicatedFixtureIDs", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetDuplicatedObjectIds', async function (object)
{
    let result = await LightRightCall("LR_GetDuplicatedObjectIds", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetTrussCrossSection', async function (object)
{
    let result = await LightRightCall("LR_GetTrussCrossSection", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetCrossSectionTemplate', async function (object)
{
    let result = await LightRightCall("LR_SetCrossSectionTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteCrossSectionTemplate', async function (object)
{
    let result = await LightRightCall("LR_DeleteCrossSectionTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DuplicateCrossSectionTemplate', async function (object)
{
    let result = await LightRightCall("LR_DuplicateCrossSectionTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddCrossSectionTemplate', async function (object)
{
    let result = await LightRightCall("LR_AddCrossSectionTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetMaterialTemplates', async function (object)
{
    let result = await LightRightCall("LR_GetMaterialTemplates", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetMaterialTemplate', async function (object)
{
    let result = await LightRightCall("LR_SetMaterialTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddMaterialTemplate', async function (object)
{
    let result = await LightRightCall("LR_AddMaterialTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteMaterialTemplate', async function (object)
{
    let result = await LightRightCall("LR_DeleteMaterialTemplate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_MergeSelectedObjects', async function (object)
{
    let result = await LightRightCall("LR_MergeSelectedObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_InsertDropForSelectedObjects', async function (object)
{
    let result = await LightRightCall("LR_InsertDropForSelectedObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_InsertBridlesForSelectedObjects', async function (object)
{
    let result = await LightRightCall("LR_InsertBridlesForSelectedObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_InsertGrappelsForSelectedObjects', async function (object)
{
    let result = await LightRightCall("LR_InsertGrappelsForSelectedObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CurveTrussForSelectedObjects', async function (object)
{
    let result = await LightRightCall("LR_CurveTrussForSelectedObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_InsertTrussCrossForSelectedObjects', async function (object)
{
    let result = await LightRightCall("LR_InsertTrussCrossForSelectedObjects", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CreateAssemblyGroupFromStructures', async function (object)
{
    let result = await LightRightCall("LR_CreateAssemblyGroupFromStructures", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewConnection', async function (object)
{
    let result = await LightRightCall("LR_AddNewConnection", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewLoadCombination', async function (object)
{
    let result = await LightRightCall("LR_AddNewLoadCombination", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetLoadCombinations', async function (object)
{
    let result = await LightRightCall("LR_GetLoadCombinations", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetLoadCombination', async function (object)
{
    let result = await LightRightCall("LR_SetLoadCombination", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteLoadCombination', async function (object)
{
    let result = await LightRightCall("LR_DeleteLoadCombination", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetLoadCombination', async function (object)
{
    let result = await LightRightCall("LR_GetLoadCombination", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewLoadGroup', async function (object)
{
    let result = await LightRightCall("LR_AddNewLoadGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetLoadGroups', async function (object)
{
    let result = await LightRightCall("LR_GetLoadGroups", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetLoadGroup', async function (object)
{
    let result = await LightRightCall("LR_SetLoadGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteLoadGroup', async function (object)
{
    let result = await LightRightCall("LR_DeleteLoadGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetLoadGroup', async function (object)
{
    let result = await LightRightCall("LR_GetLoadGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetActiveLoadCombination', async function (object)
{
    let result = await LightRightCall("LR_GetActiveLoadCombination", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetActiveLoadCombinationSupport', async function (object)
{
    let result = await LightRightCall("LR_SetActiveLoadCombinationSupport", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetActiveLoadCombinationTipping', async function (object)
{
    let result = await LightRightCall("LR_SetActiveLoadCombinationTipping", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AddNewSavedView', async function (object)
{
    let result = await LightRightCall("LR_AddNewSavedView", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSavedViews', async function (object)
{
    let result = await LightRightCall("LR_GetSavedViews", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetSavedView', async function (object)
{
    let result = await LightRightCall("LR_SetSavedView", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_DeleteSavedView', async function (object)
{
    let result = await LightRightCall("LR_DeleteSavedView", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetSavedView', async function (object)
{
    let result = await LightRightCall("LR_GetSavedView", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ShowSavedView', async function (object)
{
    let result = await LightRightCall("LR_ShowSavedView", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CreateChildAssemblyGroup', async function (object)
{
    let result = await LightRightCall("LR_CreateChildAssemblyGroup", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_PrintTable', async function (object)
{
    let result = await LightRightCall("LR_PrintTable", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_PrintElectricalViewToFile', async function (object)
{
    let result = await LightRightCall("LR_PrintElectricalViewToFile", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ReadPDF', async function (object)
{
    let result = await LightRightCall("LR_ReadPDF", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_JsEngineExecute', async function (object)
{
    let result = await LightRightCall("LR_JsEngineExecute", object);
    return result;
})

//--------------------------------------------------------------------------------
// Checks
contextBridge.exposeInMainWorld('LR_AddCheckToProject' , async function(object)
{
    let result = await LightRightAsyncCall("LR_AddCheckToProject", object)
    return result
})

contextBridge.exposeInMainWorld('LR_AddCheckToUser' , async function(object)
{
    let result = await LightRightAsyncCall("LR_AddCheckToUser", object)
    return result
})
contextBridge.exposeInMainWorld('LR_ToggleProjectOwnerChecks' , async function(object)
{
    let result = await LightRightAsyncCall("LR_ToggleProjectOwnerChecks", object)
    return result
})
contextBridge.exposeInMainWorld('LR_EditScriptInCheck' , async function(object)
{
    let result = await LightRightAsyncCall("LR_EditScriptInCheck", object)
    return result
})
contextBridge.exposeInMainWorld('LR_EditCheckName' , async function(object)
{
    let result = await LightRightAsyncCall("LR_EditCheckName", object)
    return result
})
contextBridge.exposeInMainWorld('LR_SetRopeOffsetOfBridle' , async function(object)
{
    let result = await LightRightCall("LR_SetRopeOffsetOfBridle", object)
    return result
})
contextBridge.exposeInMainWorld('LR_RemoveCheckFromProject' , async function(object)
{
    let result = await LightRightAsyncCall("LR_RemoveCheckFromProject", object)
    return result
})
contextBridge.exposeInMainWorld('LR_RemoveCheckFromUser' , async function(object)
{
    let result = await LightRightAsyncCall("LR_RemoveCheckFromUser", object)
    return result
})
contextBridge.exposeInMainWorld('LR_RemoveCheck' , async function(object)
{
    let result = await LightRightAsyncCall("LR_RemoveCheck", object)
    return result
})
contextBridge.exposeInMainWorld('LR_GetChecksFromProject' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetChecksFromProject", object)
    return result
})
contextBridge.exposeInMainWorld('LR_GetChecksFromUser' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetChecksFromUser", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetCheckByID' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetCheckByID", object)
    return result
})
contextBridge.exposeInMainWorld('LR_GetProjectOwnerChecks' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetProjectOwnerChecks", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetReviewsFromUser' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetReviewsFromUser", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetGroupsFromUser' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetGroupsFromUser", object)
    return result
})

contextBridge.exposeInMainWorld('LR_CheckForUpdate' , async function(object)
{
    let result = await LightRightCall("LR_CheckForUpdate", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetBaseURL' , async function(object)
{
    let result = await LightRightCall("LR_GetBaseURL", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetPreviewTextures' , async function(object)
{
    let result = await LightRightCall("LR_SetPreviewTextures", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetPreviewTextures' , async function(object)
{
    let result = await LightRightCall("LR_GetPreviewTextures", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetPreviewTextureFromObject' , async function(object)
{
    let result = await LightRightCall("LR_GetPreviewTextureFromObject", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ExportStructuralReport' , async function(object)
{
    let result = await LightRightCall("LR_ExportStructuralReport", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetCalculationReportMarkdown' , async function(object)
{
    let result = await LightRightCall("LR_SetCalculationReportMarkdown", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetCalculationReportMarkdown' , async function(object)
{
    let result = await LightRightCall("LR_GetCalculationReportMarkdown", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetPaperworkReportMarkdown' , async function(object)
{
    let result = await LightRightCall("LR_SetPaperworkReportMarkdown", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ReturnAwaitValueFromFrontend' , async function(object)
{
    let result = await LightRightCall("LR_ReturnAwaitValueFromFrontend", object)
    return result
})


contextBridge.exposeInMainWorld('LR_GetPaperworkReportMarkdown' , async function(object)
{
    let result = await LightRightCall("LR_GetPaperworkReportMarkdown", object)
    return result
})

contextBridge.exposeInMainWorld('LR_AddCalculationReportTemplate' , async function(object)
{
    let result = await LightRightCall("LR_AddCalculationReportTemplate", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DeleteCalculationReportTemplate' , async function(object)
{
    let result = await LightRightCall("LR_DeleteCalculationReportTemplate", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetCalculationReportTemplateMap' , async function(object)
{
    let result = await LightRightCall("LR_GetCalculationReportTemplateMap", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetCalculationReportTemplate' , async function(object)
{
    let result = await LightRightCall("LR_SetCalculationReportTemplate", object)
    return result
})

contextBridge.exposeInMainWorld('LR_AddPaperworkReportTemplate' , async function(object)
{
    let result = await LightRightCall("LR_AddPaperworkReportTemplate", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DeletePaperworkReportTemplate' , async function(object)
{
    let result = await LightRightCall("LR_DeletePaperworkReportTemplate", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetPaperworkReportTemplateMap' , async function(object)
{
    let result = await LightRightCall("LR_GetPaperworkReportTemplateMap", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetPaperworkReportTemplate' , async function(object)
{
    let result = await LightRightCall("LR_SetPaperworkReportTemplate", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ExportPaperworkReport' , async function(object)
{
    let result = await LightRightCall("LR_ExportPaperworkReport", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ExportDSTV' , async function(object)
{
    let result = await LightRightCall("LR_ExportDSTV", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ExportIFC' , async function(object)
{
    let result = await LightRightCall("LR_ExportIFC", object)
    return result
})

contextBridge.exposeInMainWorld('LR_LRNET_ConnectionAccept' , async function(object)
{
    let result = await LightRightCall("LR_LRNET_ConnectionAccept", object)
    return result
})

contextBridge.exposeInMainWorld('LR_UpdateFromBranch' , async function(object)
{
    let result = await LightRightCall("LR_UpdateFromBranch", object)
    return result
})

contextBridge.exposeInMainWorld('LR_AddDimensions' , async function(object)
{
    let result = await LightRightCall("LR_AddDimensions", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DuplicateResource' , async function(object)
{
    let result = await LightRightCall("LR_DuplicateResource", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DeleteUnusedObjects' , async function(object)
{
    let result = await LightRightCall("LR_DeleteUnusedObjects", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DeleteResource' , async function(object)
{
    let result = await LightRightCall("LR_DeleteResource", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DeleteTexture' , async function(object)
{
    let result = await LightRightCall("LR_DeleteTexture", object)
    return result
})

contextBridge.exposeInMainWorld('LR_Import2DPlanFromHostApplication' , async function(object)
{
    let result = await LightRightCall("LR_Import2DPlanFromHostApplication", object)
    return result
})

contextBridge.exposeInMainWorld('LR_Import3DPlanFromHostApplication' , async function(object)
{
    let result = await LightRightCall("LR_Import3DPlanFromHostApplication", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ImportStructuralMemberFromHoistApplication' , async function(object)
{
    let result = await LightRightCall("LR_ImportStructuralMemberFromHoistApplication", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetLastFixtureTypes' , async function(object)
{
    let result = await LightRightCall("LR_GetLastFixtureTypes", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetLastUsedSymbolDefs' , async function(object)
{
    let result = await LightRightCall("LR_GetLastUsedSymbolDefs", object)
    return result
})

contextBridge.exposeInMainWorld('LR_Export' , async function(object)
{
    let result = await LightRightCall("LR_Export", object)
    return result
})

contextBridge.exposeInMainWorld('LR_Import' , async function(object)
{
    let result = await LightRightCall("LR_Import", object)
    return result
})


contextBridge.exposeInMainWorld('LR_AddNewNote' , async function(object)
{
    let result = await LightRightCall("LR_AddNewNote", object)
    return result
})



contextBridge.exposeInMainWorld('LR_DeleteNote' , async function(object)
{
    let result = await LightRightCall("LR_DeleteNote", object)
    return result
})



contextBridge.exposeInMainWorld('LR_SetNote' , async function(object)
{
    let result = await LightRightCall("LR_SetNote", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetNotes' , async function(object)
{
    let result = await LightRightCall("LR_GetNotes", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ShowCreateDrawingNote' , async function(object)
{
    let result = await LightRightCall("LR_ShowCreateDrawingNote", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ShowAddUserToProject' , async function(object)
{
    let result = await LightRightCall("LR_ShowAddUserToProject", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetUserAvatarAsync' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetUserAvatarAsync", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetNotesForObjects' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetNotesForObjects", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ShowWorkSheet' , async function(object)
{
    let result = await LightRightCall("LR_ShowWorkSheet", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetForcedWorksheet' , async function(object)
{
    let result = await LightRightCall("LR_GetForcedWorksheet", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetProjectMembers' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetProjectMembers", object)
    return result
})

contextBridge.exposeInMainWorld('LR_AddProjectMember' , async function(object)
{
    let result = await LightRightAsyncCall("LR_AddProjectMember", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetRoleInProject' , async function(object)
{
    let result = await LightRightAsyncCall("LR_SetRoleInProject", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SendInvite', async function(object)
{
    let result = await LightRightAsyncCall("LR_SendInvite", object)
    return result
})

contextBridge.exposeInMainWorld('LR_FindUserSubset', async function(object)
{
    let result = await LightRightAsyncCall("LR_FindUserSubset", {searchQuery: object})
    return result
})

contextBridge.exposeInMainWorld('LR_SetTableViewLocalization' , async function(object)
{
    let result = await LightRightAsyncCall("LR_SetTableViewLocalization", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetActiveLoadCombination', async function (object)
{
    let result = await LightRightCall("LR_SetActiveLoadCombination", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ShowCreateWorksheetDialog' , async function(object)
{
    let result = await LightRightAsyncCall("LR_ShowCreateWorksheetDialog", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetShareLinksForProject' , async function(object)
{
    let result = await LightRightAsyncCall("LR_GetShareLinksForProject", object)
    return result
})

contextBridge.exposeInMainWorld('LR_CreateShareLinkForProject' , async function(object)
{
    let result = await LightRightAsyncCall("LR_CreateShareLinkForProject", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetDefaultGlobalSettings' , async function(object)
{
    let result = await LightRightCall("LR_GetDefaultGlobalSettings", object)
    return result
})

contextBridge.exposeInMainWorld('LR_OpenHelp' , async function(object)
{
    let result = await LightRightCall("LR_OpenHelp", object)
    return result
})

contextBridge.exposeInMainWorld('LR_UpdateFromTemplate' , async function(object)
{
    let result = await LightRightCall("LR_UpdateFromTemplate", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ImportDSTV' , async function(object)
{
    let result = await LightRightCall("LR_ImportDSTV", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetDrawingSettings' , async function(object)
{
    let result = await LightRightCall("LR_GetDrawingSettings", object)
    return result
})

contextBridge.exposeInMainWorld('LR_StoreResultsAsStructuralBenchmark' , async function(object)
{
    let result = await LightRightCall("LR_StoreResultsAsStructuralBenchmark", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ReRunStructuralCalculation' , async function(object)
{
    let result = await LightRightCall("LR_ReRunStructuralCalculation", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ReReadAndRunStructuralCalculation' , async function(object)
{
    let result = await LightRightCall("LR_ReReadAndRunStructuralCalculation", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetActiveResource' , async function(object)
{
    let result = await LightRightCall("LR_GetActiveResource", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ReadDWG' , async function(object)
{
    let result = await LightRightCall("LR_ReadDWG", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ImportSVG' , async function(object)
{
    let result = await LightRightCall("LR_ImportSVG", object)
    return result
})


contextBridge.exposeInMainWorld('LR_GetLocaleResourcesCached' , async function(object)
{
    let result = await LightRightCall("LR_GetLocaleResourcesCached", object)
    return result
})

contextBridge.exposeInMainWorld('LR_MirrorSelectedObject' , async function(object)
{
    let result = await LightRightCall("LR_MirrorSelectedObject", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DeleteEmptyAssemblyGroups' , async function(object)
{
    let result = await LightRightCall("LR_DeleteEmptyAssemblyGroups", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetShortCutsSettings' , async function(object)
{
    let result = await LightRightCall("LR_GetShortCutsSettings", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ShowEditShortCutsModal' , async function(object)
{
    let result = await LightRightCall("LR_ShowEditShortCutsModal", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ResetShortCutSettings' , async function(object)
{
    let result = await LightRightCall("LR_ResetShortCutSettings", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetShortCut' , async function(object)
{
    let result = await LightRightCall("LR_SetShortCut", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ToggleRenderingMode' , async function(object)
{
    let result = await LightRightCall("LR_ToggleRenderingMode", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DuplicateSelectedObjectX_P' , async function(object)
{
    let result = await LightRightCall("LR_DuplicateSelectedObjectX_P", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DuplicateSelectedObjectY_P' , async function(object)
{
    let result = await LightRightCall("LR_DuplicateSelectedObjectY_P", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DuplicateSelectedObjectZ_P' , async function(object)
{
    let result = await LightRightCall("LR_DuplicateSelectedObjectZ_P", object)
    return result
})


contextBridge.exposeInMainWorld('LR_DuplicateSelectedObjectX_N' , async function(object)
{
    let result = await LightRightCall("LR_DuplicateSelectedObjectX_N", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DuplicateSelectedObjectY_N' , async function(object)
{
    let result = await LightRightCall("LR_DuplicateSelectedObjectY_N", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DuplicateSelectedObjectZ_N' , async function(object)
{
    let result = await LightRightCall("LR_DuplicateSelectedObjectZ_N", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetCalculationObject' , async function(object)
{
    let result = await LightRightCall("LR_SetCalculationObject", object)
    return result
})

contextBridge.exposeInMainWorld('LR_MakeFeedbackInApp' , async function(object)
{
    let result = await LightRightCall("LR_MakeFeedbackInApp", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetAvailableCommands' , async function(object)
{
    let result = await LightRightCall("LR_GetAvailableCommands", object)
    return result
})

contextBridge.exposeInMainWorld('LR_DuplicateWorksheet' , async function(object)
{
    let result = await LightRightCall("LR_DuplicateWorksheet", object)
    return result
})


contextBridge.exposeInMainWorld('LR_PatchToObject' , async function(object)
{
    let result = await LightRightCall("LR_PatchToObject", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetOnlineConfig' , async function(object)
{
    let result = await LightRightCall("LR_SetOnlineConfig", object)
    return result
})

contextBridge.exposeInMainWorld('LR_OpenLocalRessourceFolder' , async function(object)
{
    let result = await LightRightCall("LR_OpenLocalRessourceFolder", object)
    return result
})

contextBridge.exposeInMainWorld('LR_AddNewWindLoad' , async function(object)
{
    let result = await LightRightCall("LR_AddNewWindLoad", object)
    return result
})

contextBridge.exposeInMainWorld('LR_OpenLink' , async function(object)
{
    let result = await LightRightCall("LR_OpenLink", object)
    return result
})


contextBridge.exposeInMainWorld('LR_ShowResultsForSelection' , async function(object)
{
    let result = await LightRightCall("LR_ShowResultsForSelection", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetDrawingErrors' , async function(object)
{
    let result = await LightRightCall("LR_GetDrawingErrors", object)
    return result
})

contextBridge.exposeInMainWorld('LR_AdjustChainShortens' , async function(object)
{
    let result = await LightRightCall("LR_AdjustChainShortens", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GenerateNewSymbolUuids' , async function(object)
{
    let result = await LightRightCall("LR_GenerateNewSymbolUuids", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ExportAsGdtf' , async function(object)
{
    let result = await LightRightCall("LR_ExportAsGdtf", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ExportSymbols' , async function(object)
{
    let result = await LightRightCall("LR_ExportSymbols", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetStructuralResult' , async function(object)
{
    let result = await LightRightCall("LR_GetStructuralResult", object)
    return result
})

contextBridge.exposeInMainWorld('LR_GetLoadsResult' , async function(object)
{
    let result = await LightRightCall("LR_GetLoadsResult", object)
    return result
})

contextBridge.exposeInMainWorld('LR_ExportPolygon' , async function(object) {
    let result = await LightRightCall("LR_ExportPolygon", object)
    return result;
})

contextBridge.exposeInMainWorld("LR_GetAvailableOrigins", async function(object){
    let result = await LightRightAsyncCall("LR_GetAvailableOrigins", object)
    return result
})

contextBridge.exposeInMainWorld("LR_SetHoistOrigin", async function(object){
    let result = await LightRightCall("LR_SetHoistOrigin", object)
    return result
})

contextBridge.exposeInMainWorld("LR_OpenCalendar", async function(object){
    let result = await LightRightCall("LR_OpenCalendar", object)
    return result
})

contextBridge.exposeInMainWorld("LR_CheckoutRessourceDrawing", async function(object){
    let result = await LightRightCall("LR_CheckoutRessourceDrawing", object)
    return result
})

contextBridge.exposeInMainWorld("LR_CommitRessourceDrawing", async function(object){
    let result = await LightRightCall("LR_CommitRessourceDrawing", object)
    return result
})

contextBridge.exposeInMainWorld("LR_CommitRessourceDrawingApprovedChanges", async function(object){
    let result = await LightRightCall("LR_CommitRessourceDrawingApprovedChanges", object)
    return result
})

contextBridge.exposeInMainWorld("LR_PrepareSymbolsFromHostApplication", async function(object){
    let result = await LightRightCall("LR_PrepareSymbolsFromHostApplication", object)
    return result
})

contextBridge.exposeInMainWorld("LR_AddNewLineLoad", async function(object){
    let result = await LightRightCall("LR_AddNewLineLoad", object)
    return result
})

contextBridge.exposeInMainWorld("LR_RenameProperty", async function(object){
    let result = await LightRightCall("LR_RenameProperty", object)
    return result
})

contextBridge.exposeInMainWorld("LR_SetPropertyName", async function(object){
    let result = await LightRightCall("LR_SetPropertyName", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetPropertyLocalizedOverwrite", async function(object){
    let result = await LightRightCall("LR_GetPropertyLocalizedOverwrite", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ClearPropertyName", async function(object){
    let result = await LightRightCall("LR_ClearPropertyName", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ActivateInputField", async function(object){
    let result = await LightRightCall("LR_ActivateInputField", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetUsers", async function(object){
    let result = await LightRightCall("LR_GetUsers", object)
    return result
})

contextBridge.exposeInMainWorld("LR_SetUser", async function(object){
    let result = await LightRightCall("LR_SetUser", object)
    return result
})

contextBridge.exposeInMainWorld("LR_DeleteUser", async function(object){
    let result = await LightRightCall("LR_DeleteUser", object)
    return result
})

contextBridge.exposeInMainWorld("LR_AddNewUser", async function(object){
    let result = await LightRightCall("LR_AddNewUser", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetUserResource", async function(object){
    let result = await LightRightCall("LR_GetUserResource", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetUserResourceAsync", async function(object){
    let result = await LightRightAsyncCall("LR_GetUserResourceAsync", object)
    return result
})

contextBridge.exposeInMainWorld("LR_TryToGetUserAccountAsync", async function(object){
    let result = await LightRightAsyncCall("LR_TryToGetUserAccountAsync", object)
    return result
})
    
contextBridge.exposeInMainWorld("LR_RemoveColumn", async function(object){
    let result = await LightRightAsyncCall("LR_RemoveColumn", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ShowShareDialog", async function(object){
    let result = await LightRightAsyncCall("LR_ShowShareDialog", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetFoldersAsync", async function(object){
    let result = await LightRightAsyncCall("LR_GetFoldersAsync", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetDataForUserAsync", async function(object){
    let result = await LightRightAsyncCall("LR_GetDataForUserAsync", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ReadSketchUp", async function(object){
    let result = await LightRightCall("LR_ReadSketchUp", object)
    return result
})


contextBridge.exposeInMainWorld("LR_ReadIFC", async function(object){
    let result = await LightRightCall("LR_ReadIFC", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ImportMeshScene", async function(object){
    let result = await LightRightCall("LR_ImportMeshScene", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ExportView", async function(object){
    let result = await LightRightCall("LR_ExportView", object)
    return result
})


contextBridge.exposeInMainWorld("LR_DownloadAllResource", async function(object){
    let result = await LightRightCall("LR_DownloadAllResource", object)
    return result
})


contextBridge.exposeInMainWorld("LR_WritePngToDisk", async function(object){
    let result = await LightRightCall("LR_WritePngToDisk", object)
    return result
})

contextBridge.exposeInMainWorld("LR_InstallLightRightPlugin", async function(object){
    let result = await LightRightCall("LR_InstallLightRightPlugin", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ShowChangeFixtureType", async function(object){
    let result = await LightRightCall("LR_ShowChangeFixtureType", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ResolveMultipleOutputUsage", async function(object){
    let result = await LightRightCall("LR_ResolveMultipleOutputUsage", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ReadVectorworksDrawing", async function(object){
    let result = await LightRightCall("LR_ReadVectorworksDrawing", object)
    return result
})
contextBridge.exposeInMainWorld("LR_ResetElectricalPosition", async function(object){
    let result = await LightRightCall("LR_ResetElectricalPosition", object)
    return result
})

contextBridge.exposeInMainWorld("LR_RefreshSymbolsFromHostApplication", async function(object){
    let result = await LightRightCall("LR_RefreshSymbolsFromHostApplication", object)
    return result
})


contextBridge.exposeInMainWorld("LR_AddNewLog100Connection", async function(object){
    let result = await LightRightCall("LR_AddNewLog100Connection", object)
    return result
})


contextBridge.exposeInMainWorld("LR_GetLog100Connections", async function(object){
    let result = await LightRightCall("LR_GetLog100Connections", object)
    return result
})


contextBridge.exposeInMainWorld("LR_SetLog100Connections", async function(object){
    let result = await LightRightCall("LR_SetLog100Connections", object)
    return result
})


contextBridge.exposeInMainWorld("LR_DeleteLog100Connections", async function(object){
    let result = await LightRightCall("LR_DeleteLog100Connections", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ShowLoadCellMonitor", async function(object){
    let result = await LightRightCall("LR_ShowLoadCellMonitor", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ShowCalculationOverview", async function(object){
    let result = await LightRightCall("LR_ShowCalculationOverview", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ReRunElectricalCalculation", async function(object){
    let result = await LightRightCall("LR_ReRunElectricalCalculation", object)
    return result
})

contextBridge.exposeInMainWorld("LR_DebugGraphSystem", async function(object){
    let result = await LightRightCall("LR_DebugGraphSystem", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ShowTrussDataGenerator", async function(object){
    let result = await LightRightCall("LR_ShowTrussDataGenerator", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ShowHotpatchForSelectedObjects", async function(object){
    let result = await LightRightCall("LR_ShowHotpatchForSelectedObjects", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ConvertToStructure", async function(object){
    let result = await LightRightCall("LR_ConvertToStructure", object)
    return result
})


contextBridge.exposeInMainWorld("LR_WriteSymbolsToHostApplication", async function(object){
    let result = await LightRightCall("LR_WriteSymbolsToHostApplication", object)
    return result
})

contextBridge.exposeInMainWorld("LR_CalculateChainShortenEffect", async function(object){
    let result = await LightRightCall("LR_CalculateChainShortenEffect", object)
    return result
})

contextBridge.exposeInMainWorld("LR_CalculateLoadForHoist", async function(object){
    let result = await LightRightCall("LR_CalculateLoadForHoist", object)
    return result
})

contextBridge.exposeInMainWorld("LR_CalculateBallastForGroundSupports", async function(object){
    let result = await LightRightCall("LR_CalculateBallastForGroundSupports", object)
    return result
})

contextBridge.exposeInMainWorld("LR_PlaceHoistsToStructure", async function(object){
    let result = await LightRightCall("LR_PlaceHoistsToStructure", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ShowCalculationSettings", async function(object){
    let result = await LightRightCall("LR_ShowCalculationSettings", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ReloadUI", async function(object){
    let result = await LightRightCall("LR_ReloadUI", object)
    return result
})


contextBridge.exposeInMainWorld("LR_RandomizeChainShorten", async function(object){
    let result = await LightRightCall("LR_RandomizeChainShorten", object)
    return result
})

contextBridge.exposeInMainWorld("LR_AddAndRemoveElectricalObjectConnection", async function(object){
    let result = await LightRightCall("LR_AddAndRemoveElectricalObjectConnection", object)
    return result
})

contextBridge.exposeInMainWorld("LR_SetUsedCables", async function(object){
    let result = await LightRightCall("LR_SetUsedCables", object)
    return result
})

contextBridge.exposeInMainWorld("LR_WriteSvgToDisk", async function(object){
    let result = await LightRightCall("LR_WriteSvgToDisk", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ExportMeshScene", async function(object){
    let result = await LightRightCall("LR_ExportMeshScene", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetMVRxchangeServices", async function(object){
    let result = await LightRightAsyncCall("LR_GetMVRxchangeServices", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetMVRxchangeInterfaces", async function(object){
    let result = await LightRightAsyncCall("LR_GetMVRxchangeInterfaces", object)
    return result
})

contextBridge.exposeInMainWorld("LR_MVRxchnageSelectInterface", async function(object){
    let result = await LightRightAsyncCall("LR_MVRxchnageSelectInterface", object)
    return result
})

contextBridge.exposeInMainWorld("LR_HotPatchSelectedObjects", async function(object){
    let result = await LightRightCall("LR_HotPatchSelectedObjects", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetMVRxchangeFiles", async function(object){
    let result = await LightRightCall("LR_GetMVRxchangeFiles", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetMVRxchangeFile", async function(object){
    let result = await LightRightCall("LR_GetMVRxchangeFile", object)
    return result
})

contextBridge.exposeInMainWorld("LR_OpenMVRxchangeSettings", async function(object){
    let result = await LightRightCall("LR_OpenMVRxchangeSettings", object)
    return result
})

contextBridge.exposeInMainWorld("LR_CreateNewMVRxchangeRevision", async function(object){
    let result = await LightRightCall("LR_CreateNewMVRxchangeRevision", object)
    return result
})

contextBridge.exposeInMainWorld("LR_SimulateWindLoad", async function(object){
    let result = await LightRightCall("LR_SimulateWindLoad", object)
    return result
})

contextBridge.exposeInMainWorld("LR_UploadProvedStructuralReport", async function(object){
    let result = await LightRightAsyncCall("LR_UploadProvedStructuralReport", object)
    return result
})

contextBridge.exposeInMainWorld("LR_GetTabledCalculations", async function(object){
    let result = await LightRightAsyncCall("LR_GetTabledCalculations", object)
    return result
})

contextBridge.exposeInMainWorld("LR_CancelTabledCalculation", async function(object){
    let result = await LightRightAsyncCall("LR_CancelTabledCalculation", object)
    return result
})

contextBridge.exposeInMainWorld("LR_DownloadTabledCalculation", async function(object){
    let result = await LightRightAsyncCall("LR_DownloadTabledCalculation", object)
    return result
})

contextBridge.exposeInMainWorld("LR_ImportLRWX", async function(object){
    let result = await LightRightCall("LR_ImportLRWX", object)
    return result
})


contextBridge.exposeInMainWorld("LR_ScaleByDistance", async function(object){
    let result = await LightRightCall("LR_ScaleByDistance", object)
    return result
})

contextBridge.exposeInMainWorld("LR_AddNewPointLoad", async function(object){
    let result = await LightRightCall("LR_AddNewPointLoad", object)
    return result
})


contextBridge.exposeInMainWorld("LR_ChangeWorksheetOrder", async function(object){
    return await LightRightCall("LR_ChangeWorksheetOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeLayerOrder", async function(object){
    return await LightRightCall("LR_ChangeLayerOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeClassOrder", async function(object){
    return await LightRightCall("LR_ChangeClassOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeColorCodeObjectOrder", async function(object){
    return await LightRightCall("LR_ChangeColorCodeObjectOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeDepartmentObjectOrder", async function(object){
    return await LightRightCall("LR_ChangeDepartmentObjectOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeLoadCombinationOrder", async function(object){
    return await LightRightCall("LR_ChangeLoadCombinationOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeLoadGroupOrder", async function(object){
    return await LightRightCall("LR_ChangeLoadGroupOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeSavedViewOrder", async function(object){
    return await LightRightCall("LR_ChangeSavedViewOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeTruckOrder", async function(object){
    return await LightRightCall("LR_ChangeTruckOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangePrintLabelOrder", async function(object){
    return await LightRightCall("LR_ChangePrintLabelOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeCaseOrder", async function(object){
    return await LightRightCall("LR_ChangeCaseOrder", object)
})

contextBridge.exposeInMainWorld("LR_ChangeRackOrder", async function(object){
    return await LightRightCall("LR_ChangeRackOrder", object)
})

contextBridge.exposeInMainWorld("LR_ShowRequestCalculationCheck", async function(object){
    return await LightRightCall("LR_ShowRequestCalculationCheck", object)
})

contextBridge.exposeInMainWorld("LR_SetConnectorsTemplate", async function(object){
    return await LightRightCall("LR_SetConnectorsTemplate", object)
})

contextBridge.exposeInMainWorld("LR_AddConnectorsTemplate", async function(object){
    return await LightRightCall("LR_AddConnectorsTemplate", object)
})

contextBridge.exposeInMainWorld("LR_DeleteConnectorsTemplate", async function(object){
    return await LightRightCall("LR_DeleteConnectorsTemplate", object)
})

contextBridge.exposeInMainWorld("LR_WriteCrossSection", async function(object){
    return await LightRightCall("LR_WriteCrossSection", object)
})

contextBridge.exposeInMainWorld('LR_GetCalcResults' , async function(object)
{
    let result = await LightRightCall("LR_GetCalcResults", object)
    return result
})

contextBridge.exposeInMainWorld('LR_SetUsedSupportParts', async function (object) 
{
    let result = await LightRightCall("LR_SetUsedSupportParts", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_GetAvailabelFonts', async function (object) 
{
    let result = await LightRightCall("LR_GetAvailabelFonts", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_ProcessMagicString', async function (object) 
{
    let result = await LightRightCall("LR_ProcessMagicString", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_CalculateConstructionHeight', async function (object) 
{
    let result = await LightRightCall("LR_CalculateConstructionHeight", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_AwaitCalculate', async function (object) 
{
    let result = await LightRightCall("LR_AwaitCalculate", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_TestSentry_Crash', async function (object) 
{
    let result = await LightRightCall("LR_TestSentry_Crash", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_TestSentry_StackOverflow', async function (object) 
{
    let result = await LightRightCall("LR_TestSentry_StackOverflow", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_ExportTradeShowLoadExchange', async function (object) 
{
    let result = await LightRightCall("LR_ExportTradeShowLoadExchange", object);
    return result;
})


contextBridge.exposeInMainWorld('LR_ImportTradeShowLoadExchange', async function (object) 
{
    let result = await LightRightCall("LR_ImportTradeShowLoadExchange", object);
    return result;
})

contextBridge.exposeInMainWorld('LR_SetCableColor', async function (object) 
{
    let result = await LightRightCall("LR_SetCableColor", object);
    return result;
})

